import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { forEach, cloneDeep, isEmpty, size } from 'lodash';
import Dropzone from 'react-dropzone';

import Modal from 'react-modal';

// inner imports
import { isBandFinderType } from '../../../utils';

// css imports
import '../stylesModal.css';
import './styles.css';

// actions
import { saveDatatypes } from '../../../Actions/admin';
import { getDatatypes } from '../../../Actions/main';

// elements
import { ButtonSimple } from '../../../Components/Elements/Buttons';

class CategoryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: {},
            files: {}
        };
    }

    getInitialSubCategories(datatypes, type) {
        if (datatypes && type === 'liveMusic') {
            return datatypes.subCategories[Object.keys(datatypes.subCategories)[0]] || [];
        }

        return []
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.datatypes && nextProps.catEdit) {
            this.setState({
                categoryName: nextProps.catEdit.name,
                categoryText: nextProps.catEdit.text,
                packageOneBounce: nextProps.catEdit.bounce && nextProps.catEdit.bounce.free,
                packageTwoBounce: nextProps.catEdit.bounce && nextProps.catEdit.bounce.mid,
                packageThreeBounce: nextProps.catEdit.bounce && nextProps.catEdit.bounce.high,
                packageFourBounce: nextProps.catEdit.bounce && nextProps.catEdit.bounce.huge,
                subCategories: nextProps.datatypes.subCategories[nextProps.catEdit.name],
                images: nextProps.catEdit.images
            })
        } else {
            this.setState({
                categoryName: '',
                categoryText: '',
                packageOneBounce: nextProps.datatypes.categories[nextProps.type][0] && nextProps.datatypes.categories[nextProps.type][0].bounce.free,
                packageTwoBounce: nextProps.datatypes.categories[nextProps.type][0] && nextProps.datatypes.categories[nextProps.type][0].bounce.mid,
                packageThreeBounce: nextProps.datatypes.categories[nextProps.type][0] && nextProps.datatypes.categories[nextProps.type][0].bounce.high,
                packageFourBounce: nextProps.datatypes.categories[nextProps.type][0] && nextProps.datatypes.categories[nextProps.type][0].bounce.huge,
                subCategories: this.getInitialSubCategories(nextProps.datatypes, nextProps.type),
                images: {},
                files: {}
            })
        }
    }

    updateEvent(event) {
        let value = event.target.value;
        if (event.target.name === 'subCategories') {
            value = event.target.value.split(',').map(x => x.trim());
            if (value[0] === '') {
                value = []
            }
        }

        if (event.target.name.includes('package')) {
            value = parseInt(value, 0);

            // dont allow negative bounce times
            if (value < 0) {
                value = 0;
            }

            // limit all bouncing values to max 6 times a day
            if (event.target.name.includes('Bounce') && value > 6) {
                value = 6;
            }
        }

        this.setState({[event.target.name]: value})
    }

    saveCategories() {
        if (!this.props.type || !this.props.datatypes || !this.props.datatypes.categories[this.props.type]) {
            return alert(`Something went wrong make sure ${this.props.type} exists`)
        }

        if (!this.state.categoryName || !this.state.categoryText || (!isBandFinderType(this.props.type) && this.state.subCategories.length === 0)) {
            alert('Category name, text and sub categories cant be empty');
            return;
        }

        if (!this.state.categoryName.match(/^[a-z]+$/)) {
            alert('You can only use a-z letters for the category name, no spaces');
            return;
        }

        // only on new category (allow on update) check for naming duplication
        if (!this.props.catEdit && this.props.datatypes.categories[this.props.type].find(cat => cat.name === this.state.categoryName.toLowerCase())) {
            alert('Category already exists - Category Name must be unique');
            return;
        }

        let dataTypes = JSON.parse(JSON.stringify(this.props.datatypes));

        const updateData = {
            name: this.state.categoryName.toLowerCase(),
            text: this.state.categoryText,
            singular: this.state.categoryText,
            bounce: {
                free: this.state.packageOneBounce,
                mid: this.state.packageTwoBounce,
                high: this.state.packageThreeBounce,
                huge: this.state.packageFourBounce
            },
            images: this.state.images
        };

        let catIndex = -1;

        // if band finder type - all bounce are for all the categories
        if (isBandFinderType(this.props.type)) {
            forEach(dataTypes.categories[this.props.type], c => {
                c.bounce = {
                    free: this.state.packageOneBounce,
                    mid: this.state.packageTwoBounce,
                    high: this.state.packageThreeBounce,
                    huge: this.state.packageFourBounce
                }
            });
        }

        // adding a new category
        if (!this.props.catEdit) {
            dataTypes.categories[this.props.type].push(updateData);

        // updating an existing category
        } else {
            forEach(dataTypes.categories[this.props.type], (c, i) => {
                if (c.name === this.state.categoryName) {
                    catIndex = i;
                    return false;
                }
            });

            if (catIndex >= 0) {
                dataTypes.categories[this.props.type][catIndex] = updateData;
            }
        }

        if (!isBandFinderType(this.props.type)) {
            dataTypes.subCategories[this.state.categoryName] = this.state.subCategories;
        } else {
            // updating live music and services category if was opened from the category card
            this.props.saveDatatypes(this.props.token, dataTypes, null, this.props.type, this.state.categoryName, catIndex).then(() => {
                this.props.getDatatypes();
                this.props.closeModal();
            });

            return alert(`Category ${this.state.categoryName} updated`);
        }

        // check for six icons in total saved or new, or dont save
        const filesLength = size(this.state.files) || 0;
        const imagesLength = this.state.images.length || 0;

        if (imagesLength + filesLength < 7) {
            alert('You cant create a category with less then seven icons');
            return;
        }

        // updating live music and services category if was opened from the category card
        this.props.saveDatatypes(this.props.token, dataTypes, this.state.files, this.props.type, this.state.categoryName, catIndex).then(() => {
            this.props.getDatatypes();
            this.props.closeModal();
        });
    }

    setImageFiles(file, group, type) {
        if (!file || !file[0]) return;
        const i = group + type;
        let newFiles = cloneDeep(this.state.files);
        newFiles[i] = file[0];
        this.setState({files: newFiles});
    }

    renderImage(group, type) {
        const i = group + type;
        if (isEmpty(this.state.files) && isEmpty(this.state.images)) return;

        let imageUrl = '';
        if (this.state.images && this.state.images.length > 0 && this.state.images[0]) {
            const temp = this.state.images.filter((img) => img.imageType === i);
            if (temp && temp.length > 0) {
                imageUrl = temp[0].src;
            }
        }

        if (this.state.files[i]) {
            imageUrl = this.state.files[i].preview;
        }

        return (
            <div
                className="upload-card image-temp"
                style={{backgroundImage: 'url('+  imageUrl +')'}}
            >
                {type.toUpperCase()}
            </div>
        )
    }

    renderUploadCards(group) {
        return (
            <div className="images-upload-cards">
                <Dropzone
                    onDrop={(file) => this.setImageFiles(file, group, 'flat')}
                    minSize={100}
                    maxSize={4000000}
                    accept={"image/svg+xml"}
                    className="upload-card"
                >
                    {this.renderImage(group, 'flat')}
                    FLAT
                </Dropzone>
                <Dropzone
                    onDrop={(file) => this.setImageFiles(file, group, 'onHover')}
                    minSize={100}
                    maxSize={4000000}
                    accept={"image/svg+xml"}
                    className="upload-card"
                >
                    {this.renderImage(group, 'onHover')}
                    ON HOVER
                </Dropzone>
                <Dropzone
                    onDrop={(file) => this.setImageFiles(file, group, 'onClick')}
                    minSize={100}
                    maxSize={4000000}
                    accept={"image/svg+xml"}
                    className="upload-card"
                >
                    {this.renderImage(group, 'onClick')}
                    ON CLICK
                </Dropzone>

            </div>
        )
    }

    renderMapCategoryIcon(group) {
        return (
            <div className="images-upload-cards">
                <Dropzone
                    onDrop={(file) => this.setImageFiles(file, group, 'marker')}
                    minSize={100}
                    maxSize={4000000}
                    accept={"image/svg+xml"}
                    className="upload-card"
                >
                    {this.renderImage(group, 'marker')}
                    MAP ICON
                </Dropzone>
            </div>
        )
    }

    renderIconsMainHeader() {
        return (
            <div className={`form-icons-header ${this.props.type}`}>
                Home page icons
            </div>
        )
    }

    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    className={`modal-wrapper categories-modal-wrapper ${this.props.type}`}
                    contentLabel="Category"
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)'
                        }}}
                >
                    <div className="close-button" onClick={this.props.closeModal}>
                        X
                    </div>
                    <div className="inner-wrapper">
                        <h1>{this.props.catEdit ? 'Update' : 'ADD new'} Category</h1>
                        <div className="categories-data">
                            <div className="categories-left">
                                <input
                                    className={this.props.catEdit ? 'disabled' : ''}
                                    type="text"
                                    placeholder="Category Name"
                                    disabled={this.props.catEdit}
                                    onChange={(event) => this.updateEvent(event)}
                                    value={this.state.categoryName || ''}
                                    name="categoryName"
                                />
                                {!isBandFinderType(this.props.type) && this.renderIconsMainHeader()}
                                {!isBandFinderType(this.props.type) && this.renderUploadCards('main')}
                            </div>

                            <div className="categories-right">
                                <input
                                    type="text"
                                    onChange={(event) => this.updateEvent(event)}
                                    name="categoryText"
                                    placeholder="Category Text"
                                    value={this.state.categoryText || ''}
                                />
                                {!isBandFinderType(this.props.type) &&
                                <div className={`form-icons-header ${this.props.type}`}>
                                    Form icons
                                </div>
                                }
                                {!isBandFinderType(this.props.type) && this.renderUploadCards('form')}
                            </div>
                        </div>

                        {!isBandFinderType(this.props.type) &&
                            <div className="categories-data map-icon-wrapper">
                                {this.renderMapCategoryIcon('mapIcon')}
                            </div>
                        }

                        {!isBandFinderType(this.props.type) &&
                            <div className={`form-icons-header ${this.props.type}`}>
                                {this.props.type === 'liveMusic' ? 'ALL SUB CATEGORIES' : 'SUB CATEGORY'}
                            </div>
                        }

                        {!isBandFinderType(this.props.type) &&
                            <input
                                className="sub-categories"
                                name="subCategories"
                                type="text"
                                spellCheck={false}
                                onChange={(event) => this.updateEvent(event)}
                                value={this.state.subCategories || []}
                                placeholder="Enter sub categories separated by comma"
                            />
                        }
                        <div className={`form-icons-header ${this.props.type}`}>
                            Bounce {isBandFinderType(this.props.type) && 'for all types'}
                        </div>
                        <div className="prices-wrapper">
                            <div className="packages">
                                <div className="package">Free</div>
                                <div className="package push">Push</div>
                                <div className="package rule">Rule</div>
                                <div className="package huge">Hero</div>
                            </div>
                            <div className="prices">
                                <span>Bounce</span><input value={this.state.packageOneBounce || 0} name="packageOneBounce" type="number" onChange={(event) => this.updateEvent(event)} placeholder="bounce 1"/>
                                <span className="push">Bounce</span><input value={this.state.packageTwoBounce || 0} name="packageTwoBounce" type="number" onChange={(event) => this.updateEvent(event)} placeholder="bounce 2"/>
                                <span className="rule">Bounce</span><input value={this.state.packageThreeBounce || 0} name="packageThreeBounce" type="number" onChange={(event) => this.updateEvent(event)} placeholder="bounce 3"/>
                                <span className="huge">Bounce</span><input value={this.state.packageFourBounce || 0} name="packageFourBounce" type="number" onChange={(event) => this.updateEvent(event)} placeholder="bounce 4"/>
                            </div>
                        </div>
                        <ButtonSimple customClass={this.props.type} onPress={() => this.saveCategories()} label="SAVE" />
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    catEdit: state.main.catEdit
});

CategoryModal.propTypes = {
    token: PropTypes.string,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    datatypes: PropTypes.object,
    type: PropTypes.string,
    saveDatatypes: PropTypes.func,
    getDatatypes: PropTypes.func,
    catEdit: PropTypes.object
};

export default connect(mapStateToProps, {saveDatatypes, getDatatypes})(CategoryModal);



// WEBPACK FOOTER //
// ./src/Components/Modals/Category/CategoryModal.js